<section class="background-login">
    <div class="bg-image"></div>
    <div class="bg-blur"></div> 

    <div class="sec-login">
        <div class="content-login">
            <h1 class="title-HR">
                {{"sessionFailedParf1"|translate}}
            </h1>

            <p>
                {{"sessionFailedParf2"|translate}}
            </p>
        </div>
    </div>
</section>